import { LazyRender } from '@packages/modules/src/LazyRender/LazyRender';
import { ErrorBoundary } from '@packages/shared/src/components/ErrorBoundary/ErrorBoundary';
import { useMediaType } from '@packages/shared/src/hooks/useMediaType/useMediaType';
import type { CmsData } from '../../../interfaces/webapp_json';
import { registerFlexibleComponentsFooter } from '../../components/ComponentRecognizer/registerFlexibleComponentsFooter';
import { AreaSocket } from '../../components/Footer/AreaSocket/AreaSocket';
import { AreaTop } from '../../components/Footer/AreaTop/AreaTop.client';
import { FooterFallbackError } from './FooterFallbackError';
import { FooterFallbackLoading } from './FooterFallbackLoading';
import { FooterAccordion } from './FooterAccordion.client';
import { BlockContent } from '../../components/Footer/BlockContent/BlockContent.client';
import { CookieConsentManager } from '../../components/CookieConsentManager/CookieConsentManager.client';

// register the dynamic components
registerFlexibleComponentsFooter();

type PageRendererProps = {
  data: CmsData;
  socketOnly?: boolean;
};

export const PageRenderer = ({ data, socketOnly = false }: PageRendererProps) => {
  const isDesktop = useMediaType();

  return (
    <>
      {!socketOnly && <AreaTop data={data} />}
      <footer
        className={`bg-color-footer-main text-color-footer-contrasttext [&_button]:text-color-footer-contrasttext [&&_a]:text-color-footer-contrasttext ${socketOnly ? 'mt-[5.75rem]' : 'mt-6.5'} lg:mt-auto [&_p_a]:hover:underline! lg:[&.footer_block_badges]:flex lg:[&.footer_block_badges]:gap-3 lg:[&>p]:m-0 lg:[&>p+_p]:pt-1`}
      >
        <ErrorBoundary fallback={<FooterFallbackError />}>
          <LazyRender fallback={<FooterFallbackLoading />}>
            {!socketOnly && (
              <>{isDesktop ? <BlockContent data={data} /> : <FooterAccordion data={data} />}</>
            )}
          </LazyRender>
        </ErrorBoundary>
        <CookieConsentManager>
          <AreaSocket data={data} />
        </CookieConsentManager>
      </footer>
    </>
  );
};
